import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import WorkOrders from "@/pages/WorkOrders";
import NewWorkOrder from "@/pages/NewWorkOrder";
import WorkOrderDetail from "@/pages/WorkOrderDetail";
import Billing from "@/pages/Billing";
import InvoicePreview from "@/pages/InvoicePreview";
import Reports from "@/pages/Reports";
import MasterData from "@/pages/MasterData";
import Users from "@/pages/Users";
import HangarSettings from "@/pages/HangarSettings";
import Account from "@/pages/Account";
import OfflineBanner from "@/components/OfflineBanner";

function Shelled({ children }) {
  return <AppShell>{children}</AppShell>;
}

function HomeGate() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="text-slate-500 text-sm font-mono">Carregando…</div>
      </div>
    );
  }
  if (user === false) return <Landing />;
  return <Shelled><WorkOrders /></Shelled>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <OfflineBanner />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<HomeGate />} />
          <Route
            path="/os/nova"
            element={
              <ProtectedRoute>
                <Shelled><NewWorkOrder /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/os/:id"
            element={
              <ProtectedRoute>
                <Shelled><WorkOrderDetail /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/faturamento"
            element={
              <ProtectedRoute roles={["admin", "office"]}>
                <Shelled><Billing /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/faturamento/:id/preview"
            element={
              <ProtectedRoute roles={["admin", "office"]}>
                <InvoicePreview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/relatorios"
            element={
              <ProtectedRoute roles={["admin", "office"]}>
                <Shelled><Reports /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/cadastros"
            element={
              <ProtectedRoute roles={["admin", "office"]}>
                <Shelled><MasterData /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <ProtectedRoute roles={["admin"]}>
                <Shelled><Users /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <ProtectedRoute roles={["admin"]}>
                <Shelled><HangarSettings /></Shelled>
              </ProtectedRoute>
            }
          />
          <Route
            path="/conta"
            element={
              <ProtectedRoute>
                <Shelled><Account /></Shelled>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
